module.exports = __webpack_public_path__ + "img/683.a5724e8c.jpg";